<template>
	<div class="app-container" ref="appContainer">
		<div class="app-wrap">
			<AppHeader
				@jumpToTarget="jumpToTarget"
				:isWechat="isWechat"
				:isInTop="isInTop"
				:appHeader="baseData.appHeader"
			/>
			<AppBanner :appBanner="baseData.appBanner" />
			<AppBenifits :appBenifit="baseData.appBenifit" />
			<div class="sale-more-bg">
				<AppSale />
				<AppMore :appMore="baseData.appMore" />
			</div>
			<div class="recommend-faq-bg">
				<AppRecommend :appRecommend="baseData.appRecommend" />
				<!-- <AppBrands :appBrands="baseData.appBrands"/> -->
				<AppFaq :appFaq="baseData.appFaq" />
			</div>

			<div class="language-switch dp-f">
				<span class="cn" @click="switchLang('zh-CN')">中文</span>
				<span class="en" @click="switchLang('en')">English</span>
			</div>
			<Copyright />
			<FloatComponents />

			<modal class="paid-modal" :closeable="false" v-model="modalVisiable">
				<div slot="header"></div>
				<PaidModal />
				<slot name="paid-modal"></slot>
				<div slot="footer"></div>
			</modal>

			<!-- 微信登录跳转 -->
			<WechatTip v-if="wechatVisable" @closeWechatTip="closeWechatTip" />
		</div>
	</div>
</template>
<script>
import debounce from 'lodash/debounce'
// 公共组件  所有页面共用
import AppHeader from '../../components/base/AppHeader/index'
import AppBanner from '../../components/base/AppBanner/index'
import AppMore from './components/AppMore/index'
import AppBenifits from '../../components/base/AppBenifits'
import WechatTip from '../../components/base/WechatTip/index'
import AppRecommend from '../../components/base/AppRecommend'
import AppFaq from '../../components/base/AppFaq'
import FloatComponents from '../../components/base/FloatComponents'
import Copyright from '../../components/copyright'

// // 当前组件
import PaidModal from './components/PaidModal'
import AppSale from './components/AppSale'

import { Client } from '../../utils/client'
import * as baseData from './baseData'
import buyStore from '../../utils/buyStore'

export default {
	components: {
		AppHeader,
		AppBanner,
		AppSale,
		AppBenifits,
		AppMore,
		AppRecommend,
		AppFaq,
		FloatComponents,
		PaidModal,
		WechatTip,
		Copyright,
	},
	data() {
		return {
			isInTop: true,
			modalVisiable: false,
			wechatVisable: false,
			isWechat: Client.isWechat,
			baseData,
		}
	},
	methods: {
		handleScroll: debounce(
			function(e) {
				// 再safari上滚动到顶部时， 滚动结束后才会触发动作， 导致头部的动画延时
				// 所以试用一个阈值代替0
				this.isInTop = window.scrollY < 10
			},
			{ leading: true, maxWait: 100 },
		),
		jumpToTarget(isTop) {
			// 点击菜单时隐藏模态框, 不然看不到跳转位置
			if (isTop) {
				this.$refs.appContainer.scrollTop = 0
			} else {
				this.modalVisiable = false
			}
		},
		closeWechatTip() {
			this.wechatVisable = false
		},
		handleGlobalClick(e) {
			buyStore.$emit('bodyClicked', e)
		},
	},
	created() {
		buyStore.$on('buyTapClicked', version => {
			if (Client.isWechat) {
				this.wechatVisable = true
			} else if (!PageInfo.accountState) {
				location.href = `/d/login?next=${encodeURIComponent(location.href)}`
			} else {
				this.modalVisiable = true
				buyStore.currentVersion = version
			}
		})
		buyStore.$on('closeDetail', () => {
			this.modalVisiable = false
			buyStore.currentVersion = ''
		})
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleGlobalClick)
	},
	mounted() {
		document.addEventListener('click', this.handleGlobalClick)
		window.addEventListener('scroll', this.handleScroll)
	},
}
</script>

<style lang="scss" scoped>
.app-container {
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
.app-wrap {
	padding-top: 70px;
	background: url('./images/home-bg.svg') right top/1268px 617px no-repeat;

	//background-image: linear-gradient(31deg, #ecf4ff, #eff6ff);
}
.sale-more-bg {
	background: url('./images/home-tap-mask.svg') center 0/1920px 902px no-repeat;
}

.recommend-faq-bg {
	background: url('./images/app-recommend-bg.svg') right top/630px 816px
		no-repeat;
}

.language-switch {
	margin-top: 100px;
	justify-content: center;
	span {
		color: #575757;
		font-size: 14px;
		cursor: pointer;
	}
	.cn {
		margin-right: 24px;
	}
}

@media screen and (max-width: 1200px) {
	.app-wrap {
		background-position: 500px top;
	}
	.recommend-faq-bg {
		background-position: right -360px top 0;
	}
}

@media (min-width: 415px) {
	.app-wrap {
		>>> .modal-content {
			min-width: 560px;
		}
	}
}
@media screen and (max-width: 414px) {
	.app-wrap {
		background: #fff;
		>>> .modal-bg {
			background: #fff;
		}
		>>> .common-modal {
			z-index: 20;
		}
		>>> .modal-content {
			box-shadow: none;
			box-sizing: border-box;
			width: 100%;
			height: 100%;
			padding-top: 90px;
			overflow-y: auto;
		}
	}
	.language-switch {
		margin-top: 40px;
	}
	.is-mobile {
		display: block;
	}
	.not-mobile {
		display: none;
	}
}
</style>
